var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdmissionStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7763 47.5667L39.8084 51.7258C39.9998 51.7774 40.1749 51.8767 40.3175 52.0144C40.4602 52.1521 40.5655 52.3237 40.6238 52.5132L45.3399 68.3904C45.4132 68.6311 45.5629 68.8413 45.7664 68.9893C45.9699 69.1373 46.2161 69.215 46.4677 69.2106C46.7192 69.2062 46.9625 69.12 47.1607 68.965C47.3589 68.81 47.5012 68.5946 47.5661 68.3515L51.7252 52.3195C51.7769 52.1281 51.8762 51.9529 52.0139 51.8103C52.1516 51.6677 52.3232 51.5623 52.5127 51.504L68.3898 46.7879C68.6305 46.7146 68.8408 46.5649 68.9888 46.3614C69.1368 46.1579 69.2145 45.9117 69.2101 45.6602C69.2057 45.4086 69.1194 45.1653 68.9644 44.9671C68.8094 44.7689 68.5941 44.6266 68.351 44.5617L52.3189 40.4026C52.1275 40.351 51.9523 40.2516 51.8097 40.1139C51.6671 39.9762 51.5618 39.8046 51.5035 39.6151L46.7874 23.738C46.7141 23.4973 46.5643 23.287 46.3608 23.139C46.1573 22.991 45.9112 22.9134 45.6596 22.9178C45.408 22.9221 45.1647 23.0084 44.9665 23.1634C44.7683 23.3184 44.626 23.5337 44.5612 23.7769L40.402 39.8089C40.3504 40.0003 40.2511 40.1755 40.1134 40.3181C39.9757 40.4607 39.8041 40.5661 39.6146 40.6243L23.7374 45.3404C23.4967 45.4138 23.2865 45.5635 23.1385 45.767C22.9905 45.9705 22.9128 46.2166 22.9172 46.4682C22.9216 46.7198 23.0078 46.9631 23.1628 47.1613C23.3178 47.3595 23.5332 47.5018 23.7763 47.5667Z",
    fill: "url(#paint0_linear_1376_1307)",
    stroke: "#FCD34D",
    strokeWidth: 0.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1376_1307",
    x1: 35.6511,
    y1: 28.7425,
    x2: 56.4761,
    y2: 63.3859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FCD966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCD34"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmissionStar);
export default __webpack_public_path__ + "static/media/admissionStar.01bb870351e709a45edf9c661d665fc1.svg";
export { ForwardRef as ReactComponent };